import createActionTypes from './createActionTypes';

export const namespace = 'STORES';

export const types = createActionTypes(namespace, ['SET_CURRENT_STORE', 'DETAILS_INTERACTION', 'RESET', 'UPDATE_STORES_BY_LOCATION', 'UPDATE_STORE_OPENING_INFOS']);

export const setCurrentStore = (storeId) => {
  return {
    type: types.SET_CURRENT_STORE,
    payload: {
      storeId,
    },
  };
};

export const detailsInteraction = (interaction, storeAddress) => ({
  type: types.DETAILS_INTERACTION,
  payload: {
    interaction,
    storeAddress,
  },
});

export const resetStores = (resetState) => ({
  type: types.RESET,
  payload: { resetState },
});

export const updateStoreOpeningInfos = (storeId, storeHours) => ({
  type: types.UPDATE_STORE_OPENING_INFOS,
  payload: { storeId, storeHours },
});

export const updateStoresByLocation = (flyers) => ({
  type: types.UPDATE_STORES_BY_LOCATION,
  payload: { flyers },
});
